import { NavLink } from "react-router";

import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { filledToggleGroupSx } from "@shared";

import { DutyScheduleCounselorOptionResponse, DutyScheduleDetailResponse } from "@/api";
import { DutyScheduleTab, dutySchedulePath } from "@/router/DutyScheduleRoutes";
import { useTranslation } from "@/translations";

import { DutyScheduleCounselorFilter } from "../counselor-filter/DutyScheduleCounselorFilter";

interface Props {
  id: string;
  activeTab: DutyScheduleTab;
  dutySchedule: DutyScheduleDetailResponse;
  counselors: DutyScheduleCounselorOptionResponse[];
  counselorFilter: string[] | null;
  onCounselorFilterChange: (counselorIds: string[] | null) => void;
}

export function DutyScheduleDetailTabs({
  id,
  activeTab,
  dutySchedule,
  counselors,
  counselorFilter,
  onCounselorFilterChange,
}: Props) {
  const { t } = useTranslation();

  const tabs = [
    { key: DutyScheduleTab.DataEntry, label: t("dutySchedule.detail.tabs.dataEntry") },
    { key: DutyScheduleTab.CounselorOverview, label: t("dutySchedule.detail.tabs.counselorOverview") },
    { key: DutyScheduleTab.Distribution, label: t("dutySchedule.detail.tabs.distribution") },
  ];

  return (
    <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
      <ToggleButtonGroup
        color="primary"
        exclusive
        value={activeTab}
        aria-label={t("dutySchedule.detail.tabsAria")}
        sx={filledToggleGroupSx}
      >
        {tabs.map(({ key, label }) => (
          <ToggleButton key={key} value={key} component={NavLink} to={dutySchedulePath.byTab({ id, tab: key })}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <DutyScheduleCounselorFilter
        dutySchedule={dutySchedule}
        counselors={counselors}
        value={counselorFilter}
        onChange={onCounselorFilterChange}
      />
    </Box>
  );
}
